<template>
    <ul>
        <li
            class="ListItems"
            v-for="item in items"
            :key="item.id"
        >
            <a href="item.uri">
                {{ item.title }}
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'ListItems',
    props: {
        items: {
            type: Array
        }
    }
}
</script>
